import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { CreditLimitBadgeProps } from "./CreditLimitBadge.types"

const icon = faIcon({ name: "gauge-high", style: "regular" })

export default function CreditLimitBadge(props: CreditLimitBadgeProps) {
    const { creditLimit, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    if (creditLimit == null) {
        return (
            <Badge size={size} variant="icon" icon={icon} tooltip="No credit limit">
                No limit
            </Badge>
        )
    }

    const formatted = formatCurrency(creditLimit)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`Credit limit\n${formatted}`}>
            {formatted}
        </Badge>
    )
}
